/*!
 * wellmark v1.5.0
 * WordPress theme for wellmark.com.au
 * (c) 2019
 * UNLICENSED License
 */
// JAVASCRIPT COMPILATION
// TODO: aging scripts, look to updating. file is riddled with syntax errors and mismatched, unused code.
// Migrate each script to new custom.js in vanilla js style
// @UPDATE 2019-03-21: removed Scrollify, added TinyDrawer.
// DOCUMENT READY

require("./libs.js");
require("./fslightbox.min.js");
require("./jquery.fitvids.js");

// CUSTOM FUNCTIONS

document.addEventListener("DOMContentLoaded", function () {
  mobileMenu();
  anchorQuery();

  function mobileMenu() {
    // BUTTON CONTROL
    document
      .getElementById("mobile_expand")
      .addEventListener("click", function () {
        this.style.display = "none";
        document.body.classList.add("mobile-nav-open");
        document.getElementById("mobile_close").style.display = "block"; // Simulate fadeIn
        document.getElementById("mobile_veil").style.display = "block"; // Simulate fadeIn

        // SCROLL TO TOP
        window.scrollTo({ top: 0, behavior: "smooth" });

        // OPENS MENU
        document.getElementById("mobile_menu").style.display = "block"; // Simulate slideDown
      });

    document
      .getElementById("mobile_close")
      .addEventListener("click", function () {
        this.style.display = "none";
        document.body.classList.remove("mobile-nav-open");
        document.getElementById("mobile_menu").style.display = "none"; // Simulate slideUp
        document.getElementById("mobile_veil").style.display = "none"; // Simulate fadeOut
        document.getElementById("mobile_expand").style.display = "block"; // Simulate fadeIn

        setTimeout(function () {
          document
            .querySelectorAll(
              "#mobile_primary_nav li.menu-item-has-children .sub-menu",
            )
            .forEach((subMenu) => (subMenu.style.display = "none")); // Simulate slideUp
        }, 1000);
      });

    // BACK TO TOP BUTTON IN HOVER VEIL
    document
      .getElementById("back_to_top")
      .addEventListener("click", function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });

    // CREATE BUTTONS TO OPEN CHILD MENUS
    document
      .querySelectorAll("#mobile_primary_nav li.menu-item-has-children")
      .forEach(function (item) {
        const button = document.createElement("button");
        button.title = "touch to open sub menu";
        button.innerHTML = "&#xf0d7;";
        button.classList.add("submenu-toggle");
        item.appendChild(button);
      });

    // OPEN CHILD MENUS
    document
      .querySelectorAll("#mobile_primary_nav li.menu-item-has-children button")
      .forEach(function (button) {
        button.addEventListener("click", function () {
          const subMenu = this.nextElementSibling; // Assuming .sub-menu is the next sibling
          if (subMenu) {
            subMenu.style.display = "block"; // Simulate slideDown
          }
        });
      });
  }

  function anchorQuery() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (event) {
        const elemID = this.getAttribute("href").substring(1);
        const elem = document.getElementById(elemID);
        if (elem) {
          event.preventDefault();
          window.scrollTo({
            top: elem.offsetTop,
            behavior: "smooth",
          });
        }
      });
    });
  }
});

// TODO: remmove remnants of JQuery function call below (after it's replaced with a native JS slider script)
(function ($) {
  $(document).on("ready", function () {
    $("#wellmark_carousel").flexslider({
      animation: "slide",
      directionNav: true,
    });
  });
})(jQuery);
